import { render } from "./Receiving.vue?vue&type=template&id=6876c708"
import script from "./Receiving.vue?vue&type=script&lang=js"
export * from "./Receiving.vue?vue&type=script&lang=js"

import "./Receiving.vue?vue&type=style&index=0&id=6876c708&lang=scss"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__